import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'category_list',
    component: () =>
      import('./List').then(config => createList(config.default)),
  },
  {
    path: 'sort',
    name: 'category_sort',
    component: () => import('./Sort'),
  },
  {
    path: 'new',
    name: 'category_new',
    component: () => import('./New'),
  },
  {
    path: ':id',
    name: 'category_detail',
    component: () => import('./Detail'),
    props: true,
  },
  {
    path: ':id/edit',
    name: 'category_edit',
    component: () => import('./Edit'),
    props: true,
  },
]
